import 'react-app-polyfill/ie9';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
//import "es6-promise/auto";

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
//import App from './App';
import { Subsistemas } from './components/Subsistemas';
import { Main } from './components/Main';

import registerServiceWorker from './registerServiceWorker';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const Aap = () => (
    <BrowserRouter basename={baseUrl}>
    <Switch>
            <Route path="/Main" component={Main} />
            <Route path="/Subsistemas/:origen" component={Subsistemas} />
            <Redirect to="/Main"/>
        </Switch>
    </BrowserRouter>
    );

ReactDOM.render(<Aap />,
  rootElement);

registerServiceWorker();
